import { useState } from 'react';
import type { StoreLocatorData } from './StoreLocator.types';
import { StoreDropdown } from './StoreDropdown';
import { StoreDetails } from './StoreDetails';
import { StoreMap } from './StoreMap';
import * as Styled from './StoreLocator.styled';

interface StoreLocatorProps {
  data: StoreLocatorData;
}

export const StoreLocator = ({ data }: StoreLocatorProps) => {
  const [selectedStoreId, setSelectedStoreId] = useState<string | null>(null);

  const selectedStore =
    data.stores.find(s => s.id === selectedStoreId) ?? null;

  return (
    <Styled.Layout>
      <Styled.DetailsColumn>
        <h1>{data.heading}</h1>
        {data.intro && (
          <div dangerouslySetInnerHTML={{ __html: data.intro }} />
        )}
        <StoreDropdown
          stores={data.stores}
          selectedId={selectedStoreId}
          onSelect={setSelectedStoreId}
        />
        {selectedStore && <StoreDetails store={selectedStore} />}
      </Styled.DetailsColumn>
      <Styled.MapColumn>
        <StoreMap store={selectedStore} allStores={data.stores} />
      </Styled.MapColumn>
    </Styled.Layout>
  );
};
